import React, { useContext, useEffect, useState } from "react";

import FleetMessaging from "@/components/FleetMessaging.tsx";
import ConfirmDiscardChanges from "@/components/ModalForms/ConfirmDiscardChanges.tsx";
import SimpleModal from "@/components/SimpleModal.tsx";
import Locator from "@/locator.ts";
import { UppyContext } from "@/models/UppyContextProvider.tsx";
import { UxContext } from "@/models/UxStateProvider.tsx";

export default function FleetMessagingModal({ closeModal }: { closeModal: () => void }) {
  const {
    fleetMessageModalOpen,
    fleetMessageText: initialText,
    fleetMessageActiveChannels,
    fleetMessageLatitude,
    fleetMessageLongitude,
    setFleetMessageActiveChannels,
    resetFleetValues,
  } = useContext(UxContext);
  const [fleetMessageText, setFleetMessageText] = useState<string>(initialText ?? "");
  const [showConfirmWarning, setShowConfirmWarning] = useState<boolean>(false);

  useEffect(() => {
    if (fleetMessageModalOpen) {
      setFleetMessageText(initialText ?? "");
    }
  }, [fleetMessageModalOpen]);
  const { removeFiles } = useContext(UppyContext);

  const handleCloseModal = () => {
    removeFiles();
    const hasMessageText = fleetMessageText?.length > 0;
    const hasActiveChannelsSelected = fleetMessageActiveChannels?.length > 0;
    const hasLatorLon = fleetMessageLatitude || fleetMessageLongitude;
    if (hasMessageText || hasActiveChannelsSelected || hasLatorLon) {
      setShowConfirmWarning(() => true);
    } else {
      closeModal();
      resetFleetValues();
    }
  };

  return (
    <SimpleModal
      title={Locator.feed.input.fleetMessage.modal.name}
      sx={{ width: "1000px" }}
      closeModal={() => handleCloseModal()}
      open={fleetMessageModalOpen}
    >
      <ConfirmDiscardChanges
        id="disable-read-only-mode"
        visible={showConfirmWarning}
        deleteText="Discard Changes"
        label="Discard Changes"
        text="You have unsaved changes. Are you sure you want to continue?"
        denyCloseHandler={() => {
          setShowConfirmWarning(() => false);
        }}
        confirmCloseHandler={() => {
          setShowConfirmWarning(() => false);
          setFleetMessageActiveChannels(() => []);
          setFleetMessageText("");
          resetFleetValues();
          closeModal();
        }}
      />
      <FleetMessaging
        closeModal={() => handleCloseModal()}
        fleetMessageText={fleetMessageText}
        setFleetMessageText={setFleetMessageText}
      />
    </SimpleModal>
  );
}
